import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Label } from 'ng2-charts';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { FormControl } from '@angular/forms';
import { SocketIOService } from 'src/app/Services/socket.io.service';
import { VehicleLiveTrackService } from '../../../../store/vehicle/reducer';
import { SharedService } from '../../../../Services/shared.service';
import { MapService } from 'src/app/Services/map.service';
import { CommonServices } from 'src/app/Services/common.service';
import { Subject } from 'rxjs';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';
import { RouteData } from './routedata';
import { LoaderService } from 'src/app/Services/loader.service';
declare const $;
@Component({
  selector: 'g10-transportManager-dashboardMenu',
  templateUrl: './dashboard-old.component.html',
  styleUrls: ['./dashboard-old.component.css']
})
export class DashboardOldComponent implements OnInit {
  @ViewChild('dateTimeCheck') toPicker: ElementRef;
  isShowMaps: boolean = false;
  isShowList: boolean = true;
  mapHeight = '90.7vh';
  reloadMap: boolean = false;
  summaryInfo: any = {};
  isVehicleDataHide: boolean = false;
  serchKey = 'reg'
  serchKey2 = 'title';
  public selectedTapRouteExploar: String = 'active';
  public startDateErr: string = '';
  public errorMessage: string = '';
  public dateHideShow: boolean=true;
  public datePrependIconShow:boolean = true;
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public router: Router,
    private socket: SocketIOService,
    private socketStore: VehicleLiveTrackService,
    private share: SharedService,
    private map: MapService,
    private comService: CommonServices,
    private s3: S3BudgetService,
    private loader: LoaderService
  ) {
    this.User_type = this.storage.get('userType');
    this.share._subject.subscribe((data: any) => {
      // console.log('dashboard ', data);
      if (data.type == 'socketData') {
        this.filterData(this.selectedType);
        // console.log('socket -- ', data.data);
      }
    });


  }
  routeInfoAll = {
    vechileCnt: 40,
    pickup: 25,
    drop: 15,
    assigned: 35,
    running: 30,
    employe: 600,
    male: 350,
    female: 250,
    borded: 60,
    deboarded: 50,
    nopresent: 10,
    sosCnt: 20,
    activeCompliants: 40,
    overdueCompliants: 30,
    routeTime: '12:30',
    routePoint: 'velachery',
    pickCnt: 60
  }
  //public routeList = RouteData
  public routeList = [];
  public noActiveRouteEnable = false;

  isShowTableSearch = false;
  isHideTab = false;
  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  selectedVehicle: any = {};
  removeVehicle: any = {};
  selecte = 'vehicleposition';
  public tpmDashboardMenu = [{
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/organization/transport-manager/dashboard',
  },
  {
    label: 'SOS Panel',
    icon: 'error',
    path: '/organization/transport-manager/sospanel',
  },
  {
    label: 'Request',
    icon: 'compare_arrows',
    path: '/organization/transport-manager/request-component',
  },
  {
    label: 'Rostering ',
    icon: 'call_split',
    path: '/organization/transport-manager/rostering ',
  },
  {
    label: 'Reports',
    icon: 'report_problem',
    path: '/organization/transport-manager/reports',
  },
  {
    label: 'Information',
    icon: 'info',
    path: '/organization/transport-manager/information',
  },
    // {
    //   label:'List View',
    //   icon:'list_alt',
    //   path:'/organization/transport-manager/listview',
    // },
    // {
    //   label: 'Support Desk',
    //   icon: 'contact_support',
    //   path: '/organization/transport-manager/support-desk',
    // },
  ];
  public dot;
  public myMap: any = this.map.retMap();
  public mousePos = 0;
  public currentTab = 'Dashboard';
  public currentPath = '/organization/transport-manager/dashboard';
  public allVehicleStatusInfo = [];
  public noVehicleEnable: boolean = false;

  public tabs = {
    isRouteSummary: true,
    isRouteExploration: false,
    isRouteInformation: false,
    isOpenBookingSummary:false,
  }


  selected = new FormControl(0);
  public vehicleStatusTab: any = [
    { lable: 'All', class: 'tablinks active', param: 'all' },
    { lable: 'Moving', class: 'tablinks', param: 'moving' },
    { lable: 'Halt', class: 'tablinks', param: 'halt' },
    { lable: 'Late Update', class: 'tablinks', param: 'lateUpdate' }
  ];
  public pieChartLabels: Label[] = [['All'], ['Denied'], 'Accept'];
  public pieChartData: number[] = [300, 200, 100];
  User_type: any;
  userData: any;
  VendorInfos: any;
  public showFiller = false;
  public navIcon = 'navigate_next';
  selectedType: any;
  routeInfoSearchedValue: string = ''
  singleViewVehicle: any;
  // -------------------------
  public allVehiCnt: any = 0; movingCnt: any = 0; haltCnt = 0; lastCnt = 0;
  // ------------------------------------

  // ---------------------
  public allVehicle: any = {
    cnt: {
      all: 0,
      movement: 0,
      halt: 0,
      lastUpdate: 0
    },
    info: {
      all: [],
      movement: [],
      halt: [],
      lastUpdate: []
    }
  };
  enableDateTime: boolean = false;
  disableDate: boolean = true;
  defaultEDate: string = '';
  maxEndDate = "today";
  public startDate;
  public endDate;
  public routeTabCounts = { active: 0, all: 0, upcoming: 0 };
  public routeTabData = { active: [], all: [], upcoming: [] };
  public routeData = [];

  // single route data 
  public selectedRoute: any = {};
  public activeRouteExploration: boolean = true;
  public selectedRoutes = [];
  vehicleRegNos: any;
  ngOnInit(): void {
    this.getUserData(()=>{
      if (this.User_type != 'transport_manager') {
        this.router.navigate(['/organization/transport-manager/login']);
      }
      let chekRouteExplore = this.storage.get('routeExploration');
      if (chekRouteExplore != undefined && chekRouteExplore != null && chekRouteExplore != '') {
        // this.isVehicleDataHide = chekRouteExplore['isVehicleDataHide'];
        this.selecte = 'routeinformation';
        this.selectedTapRouteExploar = chekRouteExplore['selectedTapRouteExploar'];
        this.dashbordMenuChange('routeinformation');
  
        setTimeout(() => {
          this.selectRoute(chekRouteExplore['selectedRoute']);
          // this.storage.setData({ 'routeExploration': '' });
        }, 500)
        // this.route.navigate(['organization/transport-manager/dashboard']);
      }
      
    const orgInfo = this.storage.get('userInfo');
    setTimeout(() => {
      if (orgInfo.orgID != undefined && orgInfo.orgID != null && orgInfo.orgID != '') {
        
      this.socket.getMessages();
        this.getVehicleDetails(orgInfo.orgID);
        this.getActiveRouteInfo(orgInfo.orgID);
      }

      this.currentPath = this.router.url;
      this.defaultCircle(this.tpmDashboardMenu, this.currentPath);

      // console.log('lab content loading from ngOnInit');
      this.loadTabContant('all');
    }, 300);
    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

    });
    // setTimeout(() => {
    
    // const orgInfo = this.storage.get('userInfo');
    // console.log('orgInfo ', orgInfo)
    // setTimeout(() => {
    //   if (orgInfo.orgID != undefined && orgInfo.orgID != null && orgInfo.orgID != '') {
        
    //   this.socket.getMessages();
    //     this.getVehicleDetails(orgInfo.orgID);
    //     this.getActiveRouteInfo(orgInfo.orgID);
    //   }

    //   this.currentPath = this.router.url;
    //   this.defaultCircle(this.tpmDashboardMenu, this.currentPath);

    //   // console.log('lab content loading from ngOnInit');
    //   this.loadTabContant('all');
    // }, 300);

    // this.api.getOrgVehicleRegNos({}).then((res: any) => {
    //   if (res.status == 'success') {
    //     this.vehicleRegNos = res.data;
    //   }
    // }).catch((err) => {
    //   console.log(err);
    // });

    // }, 300);
    // this.getS3()
    /*  $('#datetimepicker').datetimepicker({
       format:'Y-m-d H:i',
       inline:true
   }); */
  }

  getUserData(CB) {
    this.api.GetCurUserOrg({}).then((res: any) => {
  if (res.status == 'success') {
    this.storage.setData({userInfo: res.data[0]});
    // this.socket.getMessages();
  }

  CB();
    }).catch((err) => {
      console.log(err);
    });
  }
  // async getS3() {
  //   console.log('GET S3 Budget')
  //   let res = await this.s3.s3GetFile({
  //     "Bucket": "dzrjjsqnpdynylcuvsgahznfioxxkjuj-emps.g10.pw/org-assets/vehicles/60866279d774d4408635033b/60cae868ef11c5a004e910b6/testimageload/testimageload",
  //     "Key": "rajatest"
  //   });

  //   console.log('RES S3 ', res);
  // }

  selectRoute(val) {
    this.routeInfoAll = val;
    this.selectedRoute = val;
    this.loadSelectedRoute();
  }

  loadSelectedRoute() {
    this.tabs.isRouteInformation = false;
    setTimeout(() => { document.getElementById(this.selectedRoute.routeID).click(); }, 100);
  }

  deleteSelectedRoute(event) {
    event.preventDefault();
    if (this.tabs.isRouteInformation) {
      this.enableRouteExploration();
      this.selectedRoute = {};
    }
  }

  enableRouteExploration() {
    document.getElementById("pills-route-exploration-tab").click();
  }

  dashbordMenuChange(val) {
    this.selectedVehicle = {};
    this.removeVehicle = {};
    this.reloadMap = true;
    if (val == 'routeinformation') this.isVehicleDataHide = true
    if (val == 'vehicleposition') this.isVehicleDataHide = false

    if (this.isVehicleDataHide) {
      this.reloadTab('isRouteSummary');
      this.activeRouteExploration = false;
      this.selectedRoute = {};
    }

    setTimeout(() => { this.reloadMap = false; })
  }
  currentPage(tabIndex: number) {
    this.currentTab = this.tpmDashboardMenu[tabIndex].label;
    this.currentPath = this.tpmDashboardMenu[tabIndex].path;
    this.getLable(tabIndex);
  }

  // Moving Dashboard Menu circleIcon
  changeCirclePos(value: number) {
    this.mousePos = value;
  }

  loadTabContant(type: string) {
    this.noVehicleEnable = false;
    this.selectedType = type;
    this.allVehicleStatusInfo = [];
    if (type == 'all') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.all];
    } else if (type == 'moving') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.movement];
    } else if (type == 'halt') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.halt];
    } else if ('lateUpdate') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.lastUpdate];
    }
    if (this.allVehicleStatusInfo.length > 0) this.noVehicleEnable = true;
    else {
      setTimeout(() => {
        this.noVehicleEnable = true;
      }, 500);
    }
    // console.log(type);
    // this.filterData(type);
  }

  async filterData(type?) {
    // console.log('update ', type);
    this.allVehicleStatusInfo = [];
    this.allVehicle.info.all = [];
    this.allVehicle.cnt.all = 0;
    this.allVehicle.cnt.movement = 0;
    this.allVehicle.cnt.halt = 0;
    this.allVehicle.cnt.lastUpdate = 0;
    this.allVehicle.info.lastUpdate = [];
    this.allVehicle.info.halt = [];
    this.allVehicle.info.movement = [];
    const data = this.socketStore.get();
    const currnentTMS = new Date().getTime();

    const restrictedDays = new Date().setDate(new Date().getDate() - 2);
    const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
    const restrictedTimestamp = new Date(restrictedDatetime).getTime();

    data.filter(async (item: any) => {

      const timeDiff = this.comService.timeDiff((item.gpsts.length>10? item.gpsts: item.gpsts *1000), currnentTMS);
      // console.log('Line 260 --> ', timeDiff, 'item.gpsts ', item.gpsts, 'currnentTMS ', currnentTMS)
      /*       if (timeDiff.hh > 4 && item.spd > 5) {
              this.allVehicle.info.lastUpdate.push(item);
              this.allVehicle.cnt.lastUpdate = this.allVehicle.info.lastUpdate.length;
            } else {
              if (item.spd <= 5) {
                this.allVehicle.info.halt.push(item);
                this.allVehicle.cnt.halt = this.allVehicle.info.halt.length;
              } else if (item.spd > 5 && timeDiff.hh <= 4) {
                this.allVehicle.info.movement.push(item);
                this.allVehicle.cnt.movement = this.allVehicle.info.movement.length;
              }
            } */
      if (restrictedTimestamp < (item.gpsts.length>10? item.gpsts: item.gpsts *1000)) {
        this.allVehicle.info.all.push(item);
        this.allVehicle.cnt.all++;
        if (timeDiff.hh > 4) {
          this.allVehicle.info.lastUpdate.push(item);
          this.allVehicle.cnt.lastUpdate = this.allVehicle.info.lastUpdate.length;
        } else {
          if (item.spd <= 5) {
            this.allVehicle.info.halt.push(item);
            this.allVehicle.cnt.halt = this.allVehicle.info.halt.length;
          } else if (item.spd > 5) {
            this.allVehicle.info.movement.push(item);
            this.allVehicle.cnt.movement = this.allVehicle.info.movement.length;
          }
        }
      }



    });

    console.log(this.allVehicle);
    if (type == 'all') {
      this.allVehicleStatusInfo = this.allVehicle.info.all;
    } else if (type == 'moving') {
      this.allVehicleStatusInfo = this.allVehicle.info.movement;
    } else if (type == 'halt') {
      this.allVehicleStatusInfo = this.allVehicle.info.halt;
    } else if ('lateUpdate') {
      this.allVehicleStatusInfo = this.allVehicle.info.lastUpdate;
    }
  }
  // Default Dashboard Menu circleIcon
  defaultCirclePos() {
    this.mousePos = this.dot;
  }
  defaultCircle(obj, value) {
    this.dot = Object.keys(obj).find(key => obj[key].path == value);
    this.currentTab = obj[this.dot].label;
    this.mousePos = this.dot;
  }
  getVehicleStatus(obj: any) {
    // console.log('geT DATa', this.socketStore.get());
    console.log('lab content loading from status');
    this.loadTabContant('all');
    this.filterData(this.selectedType);

  }
  getVehicleDetails(orgID: any) {
    const obj = { orgID };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      const orgVeh: any = {};
      orgVeh[orgID] = res.data;
    });
  }

  getLable(t) {
    this.storage.setData({ tabValue: t });
    // console.log(t, this.selected)
  }

  mapBarChart() {
    this.closeNav()
    this.isShowMaps = !this.isShowMaps;
  }
  sideNav() {
    this.showFiller = !this.showFiller;
    if (this.showFiller) {
      this.navIcon = 'navigate_before';
    } else {
      this.navIcon = 'navigate_next';
    }
  }
  checkSpeedColor(value, gpsts) {
    const spd = Number(value);
    const currnentTMS = new Date().getTime();
    const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);

    if (timeDiff.hh > 4) return 'fontcolor_orange';
    if (spd > 5) {
      if (spd > 59) { return 'fontcolor_blue'; }
      else { return 'fontcolor_green'; }
    } else { return 'fontcolor_red'; }
  }
  openNav(item) {
    this.isVehicleDataHide=true;
    this.isShowList = false;
    this.reloadMap = true;
    this.selectedVehicle = {};
    this.singleViewVehicle = item;
    this.selectedVehicle = item;

    let customStyle = {
      "width": "109px !important",
      "float": "right !important",
      "top": "10px!important",
      "margin-top": "-32px !important"
    }
    this.isVehicleDataHide= false;
    //console.log(item);
    //document.getElementById('routeInfoCollapseBtn').click();
    document.getElementById('mySidenav').style.display = 'block';
    this.mapHeight = '73.7vh';
    setTimeout(() => { this.reloadMap = false; }, 10);
  }
  selectedData(e) {
    // console.log(e);
    this.isShowMaps = !this.isShowMaps;
    /* this.openNav(e); */
  }

  //date picker
  dateFromAction(obj: any = {}, type) {
    if (type == 'startDate') {
      this.startDate = obj.selectedDates;
      this.defaultEDate = obj.dateStr;
    }
    if (type == 'endDate') {
      this.endDate = obj.selectedDates;
    }
    /*  obj.selectedDates.map((x: any) => {
       this.formObject[type] = x.getTime();
       // console.log(x.getTime())
     }); */
  }

  closeNav() {
    //document.getElementById('mySidenav').style.width = '0';
    this.isShowList = true;
    this.dateHideShow =false;
    this.startDate = undefined;
    this.endDate = undefined;
    this.startDateErr = '';
    this.errorMessage= '';
    this.defaultEDate = undefined;
    this.reloadMap = true;
    this.removeVehicle = { ...this.selectedVehicle };
    this.selectedVehicle = {};
    this.singleViewVehicle = {};
    document.getElementById('mySidenav').style.display = 'none';
    this.mapHeight = '90.7vh';
    this.summaryInfo = {};
    setTimeout(() => { this.dateHideShow= true; this.reloadMap = false; }, 10);
    console.log(this.isShowMaps, this.map, this.selectedVehicle);
  }

 
  async submitNav() {
    /* let startTime=this.routeStartTime.nativeElement.value;
    let endTime=this.routeEndTime.nativeElement.value;
    console.log(startTime,endTime); */
    /*  console.log(this.routeStartTime,this.routeEndTime); */
    this.loader.show();
    let startTimeStamp: any, endTimeStamp: any;
    startTimeStamp = new Date(this.startDate).getTime();
    endTimeStamp = new Date(this.endDate).getTime();
    this.startDateErr = '', this.errorMessage = '';
    if (this.startDate == '' || this.startDate == null || this.startDate == undefined) {
      this.startDateErr = 'Start date is required.';
    } else if (this.endDate == '' || this.endDate == null || this.endDate == undefined) {
      this.errorMessage = 'End date is required.';
    } else if (startTimeStamp > endTimeStamp) {
      this.errorMessage = 'End date should be less than start date.';

    }
    console.log('start ', this.startDate, this.endDate);
    // let 
    const arr: any = [];
    let getDaysArray: any = function (start, end) {
      for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        const date = new Date(dt);
        arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
      }
      return arr;
    };
    const pad = (num) => {
      return num > 9 ? num : '0' + num;
    };

    let dates = getDaysArray(new Date(this.startDate), new Date(this.endDate));
    let locations: any = [], nodataError = '';
    for (let day = 0; day < dates.length; day++) {
      const splitDate = dates[day].split('/');
      const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
      const url = date + '/' + this.vehicleRegNos[this.selectedVehicle['reg']] + '.z';
      const res = await this.api.readS3Data(url).catch((e) => {
        nodataError = 'Moving data not found.'
      });
      const getLatLng: any = await this.comService.filterLatLng(res);
      locations = [...locations, ...getLatLng];



    }
    if (locations && locations.length > 0) {
      this.share._subject.next({
        type: 'plot_line',
        data: locations
      })
    } else {
      if (locations.length <= 0 && nodataError != '')
        this.errorMessage = 'Moving data not found.';
    }

    this.loader.hide();
    //  console.log('Diif ',this.selectedVehicle,this.vehicleRegNos )

    // if(startTimeStamp != NaN && endTimeStamp != NaN && this.singleViewVehicle.reg){
    //   let obj = {
    //     regNo: this.singleViewVehicle.reg,
    //     startDate: startTimeStamp,
    //     endDate: endTimeStamp,
    //   };
    //   // this.summaryInfo = { ...obj};
    //   // console.log(obj);
    //   // this.closeNav();
    // }
  }

  getActiveRouteInfo(orgID) {
    const obj = { orgID: orgID, };
    // console.log(obj);
    this.api.transportManagerRouteInformation(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeData = [...res.data];
        this.separateRoute();
        this.noActiveRouteEnable = true;
        //console.log(res.data);

      }
    }).catch((err) => {
      console.log(err);
    });
  }

  patchRouteData(data) {
    console.log('DATA ', data);
    let vehiclesList=[];
    this.routeList = data.map((item: any,i:number) => {
      if(item.vehicle) vehiclesList = [...vehiclesList,...item.vehicle];
      if(data.length-1==i){
        this.share._subject.next({
          type: 'vehicle_current_location',
          data: vehiclesList
        })
      }
      return {
        title: item.title,
        trasitMode: item.trasitMode,
        attendence: typeof item.attendence == 'string' ? item.attendence : item.attendence.join(','),
        startTime: this.getTimeString(item.startTime),
        endTime: this.getTimeString(item.endTime),
        routeType: item.routeType,
        keywords: item.keywords,
        holidayPattern: item.holidayPattern,
        orgID: item.orgID,
        routeID: item.routeID,
        status: item.status,        
        fromDate: this.comService.timestampToDate(item.fromDate, 'DMY', '-'),
        vehicle: item.vehicle ? item.vehicle : [],
      };
    });
  }

  loadRouteInfo(routeKey) {
    this.patchRouteData(this.routeTabData[routeKey]);
    // console.log(routeKey)
    this.selectedTapRouteExploar = routeKey;

    if (this.tabs.isRouteExploration) {
      this.tabs.isRouteExploration = !this.tabs.isRouteExploration;
      setTimeout(() => { this.tabs.isRouteExploration = !this.tabs.isRouteExploration }, 200);
    };
  }

  separateRoute() {

    Object.keys(this.routeTabCounts).filter((key) => this.routeTabCounts[key] = 0);
    Object.keys(this.routeTabData).filter((key) => this.routeTabData[key] = []);

    let dateTime = new Date();
    let hour = dateTime.getHours();
    let setHour = new Date(dateTime.setHours(hour + 5));
    let upcomingHour = setHour.getHours();
    // console.log('upcoming Hour', upcomingHour);
    this.routeData.filter((route) => {

      this.routeTabCounts['all']++;
      this.routeTabData['all'].push(route);

      if (route.startTime <= hour && route.endTime >= hour) {
        this.routeTabCounts['active']++;
        this.routeTabData['active'].push(route);
      }
      else if (route.startTime > hour) {
        this.routeTabCounts['upcoming']++;
        this.routeTabData['upcoming'].push(route);
      }
    });
    this.patchRouteData(this.routeTabData['active']);

  }



  getTimeString(time) {                             // time '10:20'
    let timeString = String(time);
    let splitTime = timeString.split(".");            // 10, 20
    splitTime[1] = splitTime[1] == undefined ? '00' : splitTime[1];
    let hour = Number(splitTime[0]) < 10 ? '0' + splitTime[0] : splitTime[0];
    let minute = splitTime[1].length == 1 ? splitTime[1] + '0' : splitTime[1];
    // let minute = splitTime[1];
    let timeformat = `${hour}:${minute}`;
    return timeformat;
  }

  //reload tab content
  reloadTab(tab) {
    for (let key in this.tabs) {
      if (key == tab) this.tabs[key] = true;
      else this.tabs[key] = false;
    }

    if (tab == 'isRouteSummary' && tab == 'isOpenBookingSummary') {
      this.activeRouteExploration = false;
      this.selectedRoute = {};
    }
    else this.activeRouteExploration = true;

  }

  manageRoute(singleRoute) {
    let data:any={
      isVehicleDataHide: true,
      selectedRoute: singleRoute,
      selectedTapRouteExploar:this.selectedTapRouteExploar,
    }
    this.storage.setData({'routeExploration': data});
    setTimeout(()=>{
      this.router.navigate(['organization/transport-manager/rostering/edit-route/' + singleRoute['routeType'] + '/' + singleRoute['routeID'] + '/0'])
    },300)

    console.log('organization/transport-manager/rostering/edit-route/' + singleRoute.routeType + '/' + singleRoute.routeID);
    this.router.navigate(['organization/transport-manager/rostering/edit-route/' + singleRoute.routeType + '/' + singleRoute.routeID+'/0'])
  }

}
